import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
//@ts-nocheck
import React, { useState } from "react";
import GlobalSnackbar from "components/GlobalMessageSnackbar/GlobalSnackbar";

// can't flow type createContext this b/c webpack complains
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var GlobalMessageContext = /*#__PURE__*/React.createContext({
  globalMessage: null,
  variant: "default",
  showGlobalMessage: function showGlobalMessage(message, variant) {}
});

/* https://reactjs.org/docs/context.html#reactcreatecontext */
var GlobalMessageSnackbar = function GlobalMessageSnackbar(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    globalMessage = _useState2[0],
    setGlobalMessage = _useState2[1];
  var _useState3 = useState("default"),
    _useState4 = _slicedToArray(_useState3, 2),
    variant = _useState4[0],
    setVariant = _useState4[1];
  var isMounted = false;
  React.useEffect(function () {
    isMounted = true;
  });
  var showGlobalMessage = function showGlobalMessage(message) {
    var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
    if (isMounted) {
      setGlobalMessage(message);
      setVariant(variant);
    }
  };
  var hideMessage = function hideMessage() {
    setGlobalMessage(null);
  };
  var contextValue = {
    globalMessage: globalMessage,
    showGlobalMessage: showGlobalMessage,
    variant: variant
  };
  return /*#__PURE__*/_jsxs(GlobalMessageContext.Provider, {
    value: contextValue,
    children: [children, /*#__PURE__*/_jsx(GlobalSnackbar, {
      message: globalMessage,
      onClose: hideMessage,
      variant: variant
    })]
  });
};
export default GlobalMessageSnackbar;